import { DocumentCategory } from '@core/enums';
import { Expose } from 'class-transformer';

export class DocumentEntity {
  id: number;

  @Expose({ name: 'club_id' })
  clubId: number;

  @Expose({ name: 'doc_name' })
  docName: string;

  category: DocumentCategory;

  @Expose({ name: 'created_by' })
  createdBy: string;

  @Expose({ name: 'created_at' })
  createdAt: string;

  @Expose({ name: 'updated_at' })
  updatedAt: string;

  path: any;

  get documentNameWithoutExtension() {
    return this.docName.split('/').pop().split('.').shift() || 'No Name';
  }
}
